<div class="page-body">
  <div>
    <header
    [breadcrumbPath]="breadcrumb"
    ></header>
    <div class="page-content is-fullpage" >
      <div class="form-content" >

        <h2 class="strong">
          <tra slug="title_acct_actv"></tra>
        </h2>
        <tra-md slug="txt_acct_actv_instr"></tra-md>
        <p style="text-align:center; margin-bottom:1em;">
          {{email}}
        </p>
        
        <div class="notification" *ngIf="isLoading">
          <tra slug="loading_caption"></tra>
        </div>
        <div class="notification is-warning" *ngIf="isError">
          <div [ngSwitch]="errorType">
            <div *ngSwitchCase="AUTH_REG_ERROR.ALREADY_CONFIRMED">
              <tra-md slug="acct_actv_err_already"></tra-md>
              <hr/>
              <a class="button is-info is-large is-fullwidth" [routerLink]="loginRoute">
                <tra slug="lbl_proceed_to_login"></tra>
              </a>
            </div>
            <div *ngSwitchCase="AUTH_REG_ERROR.EXPIRED_CODE">
              <tra-md slug="acct_actv_err_expired"></tra-md>
            </div>
            <div *ngSwitchDefault>
              <tra-md slug="acct_actv_err_default"></tra-md>
            </div>
          </div>
        </div>
        <div *ngIf="isActivated">
          <tra-md slug="acct_actv_complete"></tra-md>
          <hr/>
          <a class="button is-info is-large" [routerLink]="loginRoute">
            <tra slug="lbl_proceed_to_login"></tra>
          </a>
        </div>

      </div>
      
    </div>
  </div>
  <footer [hasLinks]="true"></footer>
</div>



